import { FC } from 'react'

import styled from 'styled-components'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { variables } from 'src/Styled/variables'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { subscription } from 'src/Router/routes'
import { changePlanEvent } from 'src/Helpers/TagManager'
import { useAppSelector } from 'src/Hooks/redux'
import {
  getCountryName,
  getUserId,
} from 'src/Redux/auth-process/userSlice/selectors'
import { checkIsVATCountry } from 'src/Hooks/usePayment'
import { FIXED_BY, VAT_PERCENT } from 'src/Constants/constants'

const Wrapper = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.hoverWhite};
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`

export const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const PriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`
const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  line-height: 150%;
`

const LeftPriceDescription = styled(Text)`
  width: 96px;
  @media (min-width: 768px) {
    width: 184px;
  }
`
export const PlanToPay: FC = () => {
  const navigate = useNavigate()
  const userId = useAppSelector(getUserId)
  const [search] = useSearchParams()
  const plan = search.get('plan') || ''
  const country = useAppSelector(getCountryName)
  const isVATCountry = checkIsVATCountry(country)

  const handlePlanChange = (): void => {
    navigate(subscription)
    changePlanEvent({ planName: plan, userId })
  }
  const title = `Chosen plan: ${plan}`
  const price = Number(search.get('price'))
  const preceWithVAT = (price + price * VAT_PERCENT).toFixed(FIXED_BY)
  const priceWithVATText = `${preceWithVAT} (includes VAT) / month`
  const priceWithoutVATText = `$${price} / month`
  const pricePerMonth = isVATCountry ? priceWithVATText : priceWithoutVATText
  const description = `You will be automatically charged $${isVATCountry ? preceWithVAT : price} every month until you decide to cancel. You can cancel anytime on your Account Balance page.`

  return (
    <Wrapper>
      <TitleWrapper>
        <Title>{title}</Title>
        <PrimaryDottedButton onClick={handlePlanChange}>
          change plan
        </PrimaryDottedButton>
      </TitleWrapper>
      <PriceWrapper>
        <LeftPriceDescription>
          Starting today, billed monthly
        </LeftPriceDescription>
        <Text>{pricePerMonth}</Text>
      </PriceWrapper>
      <Text>{description}</Text>
    </Wrapper>
  )
}
